import {ReleaseToggleState} from "../../tools/release-toggles/release-toggle-state";
import {isEcgMeasurement} from "../measurement-models";
import {HomeType} from "../initiate-measurement/home-type";
import {NurseMeasurementType} from "../initiate-measurement/initiate-measurement-data";

export interface WeightAndHeightRequiredParams {
  eForm: boolean;
  type: NurseMeasurementType;
}

export function areWeightAndHeightRequired(params: WeightAndHeightRequiredParams): boolean {

  const homeType = new HomeType(params.type);

  if (!ReleaseToggleState.getInstance().isReleased("HEIGHT_AND_WEIGHT_NOT_MANDATORY_FOR_ECG_464")) {
    return !params.eForm || homeType.isHomeType();
  }

  return (!params.eForm || homeType.isHomeType()) && !isEcgMeasurement(homeType.getMeasurementType());
}
